export const EVENTS_ACTIONS = {
    MASTER_PLAYER: 'master_player',
    MARKET_PROJECTION: 'MARKET_PROJECTION',
    FANTASY_HISTORIC: 'fantasy-historic',
    COMPARADOR_JUGADORES: 'comparador_jugadores',
    NOTICIAS_FLASH: 'noticias_flash',
    ALINEACIONES_PROBABLES: 'alineaciones_probables',
    AD_SLOT_REFRESH: 'ad_slot_refresh',
    BET_BANNER_CLICK: 'bet_banner_click',
    BETTING_HOUSE_CLICK: 'betting_house_click',
};

export const EVENTS_CATEGORIES = {
    OPEN: 'open',
    TEAM: 'team',
    PARTIDO: 'partido',
    VIDEOO: 'videoo',
    ADS: 'ads',
    BETTING: 'betting',
};

export const EVENTS_LABELS = {
    CACHE: 'cache',
    API: 'api',
    VIDEOO: 'videoo',
};

export const logEventTracker = (action, category, label) => {
    gtag('event', action, {
        app_name: 'analitica-fantasy',
        screen_name: action,
        event_category: category ?? EVENTS_CATEGORIES.OPEN,
        event_label: label ?? EVENTS_LABELS.API,
    });
};
